import {
  CardMeta,
  CardMetaGrid,
  ManagementCard,
  ManagementCardAction,
  ManagementCardList,
} from 'components/ManagementCard'
import { TagChip } from 'components/TagChip'
import { DATE_FORMAT } from 'constants/index'
import { commonStrings, tagManagementStrings } from 'constants/strings'
import type { TTag } from 'types'
import formatDate from 'utils/formatDate'

type TagsCardListProps = {
  tags: TTag[]
  loading: boolean
  emptyMessage?: string
  onEdit: (tagId: number) => void
  onDelete: (tag: TTag) => void
  className?: string
}

export function TagsCardList({
  tags,
  loading,
  emptyMessage = tagManagementStrings.states.empty,
  onEdit,
  onDelete,
  className,
}: TagsCardListProps) {
  return (
    <ManagementCardList
      loading={loading}
      isEmpty={tags.length === 0}
      loadingMessage={commonStrings.loading}
      emptyMessage={emptyMessage}
      className={className}
    >
      {tags.map((tag) => (
        <li key={tag.id}>
          <ManagementCard
            onClick={() => onEdit(tag.id)}
            ariaLabel={`${tag.name} ${commonStrings.actions.edit}`}
            title={<TagChip name={tag.name} color={tag.color} />}
            actions={
              <ManagementCardAction
                tone="danger"
                icon="close"
                onClick={() => onDelete(tag)}
              >
                {commonStrings.actions.delete}
              </ManagementCardAction>
            }
          >
            <CardMetaGrid>
              <CardMeta
                label={tagManagementStrings.table.headers.friendCount}
                value={tag.friendCount}
              />
              <CardMeta
                label={tagManagementStrings.table.headers.createdAt}
                value={formatDate(tag.createdAt, DATE_FORMAT)}
              />
            </CardMetaGrid>
          </ManagementCard>
        </li>
      ))}
    </ManagementCardList>
  )
}
